import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/entries/entries-reducer-factory'
import { SET_CATALOG_COMPONENT, REMOVE_ALL_CATALOG_COMPONENTS } from './catalog-actions.js'

export const catalogReducer = entriesReducerFactory(SET_CATALOG_COMPONENT, REMOVE_ALL_CATALOG_COMPONENTS)
